import { useState } from 'react';
import { faq } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './Faq.css';

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <Section id="faq" label="FAQ" title="Preguntas frecuentes" lead="Respuestas rápidas antes de pedirnos una demo por WhatsApp.">
      <div className="faq-list">
        {faq.map((item, i) => (
          <ScrollReveal key={item.q} delay={i * 40}>
            <div className={`faq-item glass-card ${open === i ? 'faq-item--open' : ''}`}>
              <button
                type="button"
                className="faq-item__trigger"
                aria-expanded={open === i}
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span>{item.q}</span>
                <span className="faq-item__icon" aria-hidden>
                  +
                </span>
              </button>
              {open === i ? (
                <div className="faq-item__answer">
                  <p>{item.a}</p>
                </div>
              ) : null}
            </div>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
